import * as request from "@/utils/request";
import { getCommonAttrs } from "@didi/x-tracker";
import { DefaultConfigs, inApp } from "@/common/js/constant";
import { RISK_SDK_VERSION } from "@/components/RiskVerify/constants";
import BusinessVerify, { EnumBusinessFlow, EnumVerifyScene } from "@/components/BusinessVerify";
import { trackEvent } from "@/utils/omega";
import App from "@/utils/app";
import { setCommonAttrs } from "@didi/x-tracker";
import { GuidePageInfo, SelectPageInfo, LimitPageInfo, LimitRes } from "./types";

const baseUrl = `${DefaultConfigs.publicAPIPath}`;

// 获取引导页面信息
export function getGuidePage(): Promise<GuidePageInfo> {
  // 实际接口调用
  return request.post<GuidePageInfo>(`${baseUrl}/sofipo/v0/limit/guidePage`, {});
}

// 获取功能选择页信息
export function getSelectPage(): Promise<SelectPageInfo> {
  // 实际接口调用
  return request.post<SelectPageInfo>(`${baseUrl}/sofipo/v0/limit/choicePage`, {});
}

// 获取金额修改页信息
export function getLimitPage(params: { type?: string }): Promise<LimitPageInfo> {
  // 实际接口调用
  return request.post<LimitPageInfo>(`${baseUrl}/sofipo/v0/limit/limitPage`, params);
}

// 修改限额
export async function updateLimit(params: any): Promise<LimitRes> {
  // 根据type设置type和from_source
  let fromSource: number | undefined;
  if (params?.type === "transfer") {
    fromSource = EnumBusinessFlow.transferLimit;
  } else if (params?.type === "payment") {
    fromSource = EnumBusinessFlow.paymentLimit;
  }

  // 实际接口调用
  // 获取公参中的pub_uid
  const commonAttrs = getCommonAttrs();

  if (!params?.requestId) {
    // uid + timestamp
    params.requestId = String(commonAttrs?.pub_uid) + Date.now();
  }
  // 业务核验版本
  params.verifyInfo = params.verifyInfo || {
    verifySdkVersion: RISK_SDK_VERSION,
  };
  //风控核验版本
  params.riskInfo = params.riskInfo || {
    verifySdkVersion: RISK_SDK_VERSION,
  };

  try {
    return await request.post<LimitRes>(`${baseUrl}/sofipo/v0/limit/updateLimit`, params);
  } catch (ret: any) {
    // 风控核验
    if (ret.errno === request.ERROR_TYPE.RiskVerify) {
      // order_id 支付环节业务订单号
      setCommonAttrs({
        // scene_source
        // 场景来源
        // 0-风控
        // 1-业务
        scene_source: EnumVerifyScene.risk,
        from_source: fromSource,
      });
      // 重置业务核验参数
      params.riskInfo = {
        verifySdkVersion: RISK_SDK_VERSION,
      };

      return import("@/components/RiskVerify").then(({ default: RiskVerify }) =>
        new RiskVerify()
          .verify(JSON.parse(ret?.data?.riskInfo)?.atoDomain)
          .then((res) => {
            // 核验完成后删掉order id参数
            // setCommonAttrs({
            //     order_id: undefined
            // });
            setCommonAttrs({
              // scene_source
              // 场景来源
              // 0-风控
              // 1-业务
              scene_source: undefined,
              // from_source 流程来源
              from_source: undefined,
            });
            params.riskInfo.token = res.verify_data || "";
            params.riskInfo.sessionId = JSON.parse(ret?.data?.riskInfo)?.atoDomain?.sessionId || "";

            // 重启发起请求
            return updateLimit(params);
          })
          .catch((err) => {
            // 技术打点
            trackEvent("tech_sofi_catch_error", {
              source: "limit.RiskVerify",
              data: JSON.stringify(err),
            });
            // 挂起请求流程
            return new Promise(() => void 0);
          }),
      );
    }
    // 业务核验
    if (ret.errno === request.ERROR_TYPE.BusinessVerify) {
      // 设置公参
      setCommonAttrs({
        // scene_source
        // 场景来源
        // 0-风控
        // 1-业务
        scene_source: BusinessVerify.scene,
        from_source: fromSource,
      });

      if (inApp) {
        App.requestBackPressedControl(() => {});
      }
      // 拉起核验
      return new BusinessVerify()
        .verify(JSON.parse(ret?.data?.bussVerifyResultInfo)?.atoDomain)
        .then((res) => {
          // 设置公参
          setCommonAttrs({
            // scene_source
            // 场景来源
            // 0-风控
            // 1-业务
            scene_source: undefined,
            // from_source 流程来源
            from_source: undefined,
          });

          // 释放控制
          if (inApp) {
            App.cancelBackPressedControl();
          }
          // 增加核验token
          if (params.verifyInfo) {
            params.verifyInfo.sessionId = res.verify_session_id;
            // 核验完成
            params.verifyInfo.bussVerify = 1;
            params.sessionId = res.verify_session_id;
          }
          console.log(params, "params");
          // 重新发起请求
          return updateLimit(params);
        })
        .catch((err) => {
          // 释放控制
          if (inApp) {
            App.cancelBackPressedControl();
          }
          // 技术打点
          trackEvent("tech_sofi_catch_error", {
            source: "limit.update.BusinessVerify",
            data: JSON.stringify(err),
          });
          // 交给上层catch
          return Promise.reject(err);
        });
    }
    // 释放控制
    if (inApp) {
      App.cancelBackPressedControl();
    }
    // 交给上层catch
    return Promise.reject(ret);
  }
}
